export const sxStyles = {
  flexPosition: {
    display: 'flex',
    gap: '1.5rem',
  },
  accordionDetails: {
    display: 'flex',
    flexDirection: 'column',
    gap: '1.5rem',
  },
};
